// Daily cadence ranges (steps per minute, while walking) keyed by day relative
// to surgery. ADMIN ONLY -- the patient app has no cadence chart, so unlike the
// step table there is no patient-facing goal derived from these and no second
// copy to keep in step.
//
// 🔴 GENERATED -- DO NOT HAND-EDIT. Source of record:
//   docs/reference/tracpatch/cadence_reference.csv   (Low / High columns)
//   node docs/reference/tracpatch/generate-range-tables.js
//
// Low and High are Mean +/- 1 standard deviation over the reference cohort, so
// the band DESCRIBES where roughly the middle 68% of that cohort fell rather
// than prescribing a target.
//
// Resolution rule matches the step table: a day earlier than the first row uses
// the -10 range; a day later than the last uses the 60 range.

export const CADENCE_RANGE_BY_DAY = {
  '-10':  { min: 67, max: 112 },
  '-9':   { min: 62, max: 112 },
  '-8':   { min: 67, max: 111 },
  '-7':   { min: 65, max: 111 },
  '-6':   { min: 61, max: 112 },
  '-5':   { min: 57, max: 112 },
  '-4':   { min: 59, max: 112 },
  '-3':   { min: 55, max: 111 },
  '-2':   { min: 58, max: 109 },
  '-1':   { min: 42, max: 102 },
  '0':    { min: 26, max: 82 },
  '1':    { min: 32, max: 72 },
  '2':    { min: 28, max: 65 },
  '3':    { min: 30, max: 70 },
  '4':    { min: 34, max: 73 },
  '5':    { min: 37, max: 77 },
  '6':    { min: 39, max: 78 },
  '7':    { min: 40, max: 81 },
  '8':    { min: 41, max: 84 },
  '9':    { min: 42, max: 85 },
  '10':   { min: 43, max: 87 },
  '11':   { min: 47, max: 88 },
  '12':   { min: 45, max: 90 },
  '13':   { min: 49, max: 91 },
  '14':   { min: 49, max: 93 },
  '15':   { min: 50, max: 95 },
  '16':   { min: 52, max: 96 },
  '17':   { min: 51, max: 98 },
  '18':   { min: 53, max: 100 },
  '19':   { min: 53, max: 100 },
  '20':   { min: 55, max: 101 },
  '21':   { min: 53, max: 101 },
  '22':   { min: 56, max: 103 },
  '23':   { min: 57, max: 103 },
  '24':   { min: 56, max: 105 },
  '25':   { min: 58, max: 104 },
  '26':   { min: 55, max: 107 },
  '27':   { min: 57, max: 109 },
  '28':   { min: 60, max: 111 },
  '29':   { min: 61, max: 110 },
  '30':   { min: 60, max: 108 },
  '31':   { min: 59, max: 113 },
  '32':   { min: 61, max: 108 },
  '33':   { min: 62, max: 110 },
  '34':   { min: 60, max: 112 },
  '35':   { min: 63, max: 113 },
  '36':   { min: 65, max: 113 },
  '37':   { min: 65, max: 108 },
  '38':   { min: 63, max: 113 },
  '39':   { min: 66, max: 109 },
  '40':   { min: 63, max: 112 },
  '41':   { min: 61, max: 113 },
  '42':   { min: 62, max: 114 },
  '43':   { min: 62, max: 112 },
  '44':   { min: 66, max: 115 },
  '45':   { min: 68, max: 115 },
  '46':   { min: 65, max: 115 },
  '47':   { min: 69, max: 114 },
  '48':   { min: 66, max: 117 },
  '49':   { min: 66, max: 112 },
  '50':   { min: 68, max: 111 },
  '51':   { min: 69, max: 115 },
  '52':   { min: 68, max: 114 },
  '53':   { min: 65, max: 112 },
  '54':   { min: 68, max: 114 },
  '55':   { min: 70, max: 117 },
  '56':   { min: 66, max: 120 },
  '57':   { min: 72, max: 113 },
  '58':   { min: 66, max: 117 },
  '59':   { min: 70, max: 114 },
  '60':   { min: 70, max: 114 },
}

export const CADENCE_RANGE_MIN_DAY = -10
export const CADENCE_RANGE_MAX_DAY = 60

function clampCadenceDay(day) {
  if (day < CADENCE_RANGE_MIN_DAY) return CADENCE_RANGE_MIN_DAY
  if (day > CADENCE_RANGE_MAX_DAY) return CADENCE_RANGE_MAX_DAY
  return day
}

// { min, max } for a whole-day offset from surgery, or null.
export function cadenceRangeForDayOffset(dayOffset) {
  if (dayOffset === null || dayOffset === undefined || Number.isNaN(dayOffset)) return null
  return CADENCE_RANGE_BY_DAY[String(clampCadenceDay(dayOffset))] || null
}

export default { CADENCE_RANGE_BY_DAY, cadenceRangeForDayOffset }
